import * as generalButtons from './initialState-general-calculation';
import * as bracketButtons from './initialState-bracket-attachment';
import * as rebarButtons from './initialState-rebar-reinforcement';
import * as safetyBarrierButtons from './initialState-safety-barrier';
import * as woodConnectionButtons from './initialState-wood-connection';

import { APP_TYPES } from '@config';

import {
  SET_SQUARE_ACTIVE_BTN, SET_CIRCLE_ACTIVE_BTN, SET_TRIANGLE_ACTIVE_BTN,
  SET_STAND_OFF_ACTIVE_BTN,
  SET_PROFILE_MATERIAL, SET_PROFILE_FAMILY, SET_PROFILE_SIZE,
  SET_PROFILE_ROTATION, SET_PROFILE_ROTATE_DIRECTION,
  SET_SAFETY_BARRIER_ACTIVE_TYPE, SET_SAFETY_BARRIER_ACTIVE_SUBTYPE, SET_SAFETY_BARRIER_ACTIVE_PLATE,
  SET_CLADDING,
  SET_BRACKET_ATTACHMENT_ACTIVE_BTN, SET_REBAR_REINFORCEMENT_ACTIVE_BTN,
  RESET_PROFILES,
  SET_EDITOR_ACTIVE_BTN,
  RESET_APPLICATION_STATE,
  SET_APPLICATION_STATE,
  SET_MANUFACTURER,
  SET_DESIGNATION,
  SET_PREDEFINED_BASEPLATE,
    SET_PREDEFINED_BASEPLATE_IMAGE,
  SET_WOOD_PANEL_OPTIONS,
    SET_WOOD_CONNECTION_TYPE
} from './actions';
import { mergeDeep } from '@services/helper.service';
import { CladdingTypes } from '@object-generators/safety-barrier/objects/cladding';

export const initState = {
  generalButtons,
  bracketButtons,
  rebarButtons,
  safetyBarrierButtons,

  [APP_TYPES.GENERAL_CALCULATION]: {
    activeSquareBtn: '4',
    activeCircleBtn: null,
    activeTriangleBtn: null,
    activeEditorBtn: null,

    profile: {
      material: null,//defaultMaterialState[BRAND][APP_TYPES.GENERAL_CALCULATION],
      family: null, //defaultProfileState[APP_TYPES.GENERAL_CALCULATION][0].family,
      size: null, //defaultProfileState[APP_TYPES.GENERAL_CALCULATION][0].size,
      shape: null,

      rotation: 0,
      rotateDirection: 'right'
    },

    activeStandOffBtn: '1'
  },

  [APP_TYPES.BRACKET_ATTACHMENT]: {
    activeBtn: '3',

    profile: {
      material: null, //defaultMaterialState[BRAND][APP_TYPES.BRACKET_ATTACHMENT],
      family: null, //defaultProfileState[APP_TYPES.BRACKET_ATTACHMENT][0].family,
      size: null, //defaultProfileState[APP_TYPES.BRACKET_ATTACHMENT][0].size,
      shape: null,

      rotation: 0,
      rotateDirection: null
    }
  },

  [APP_TYPES.SAFETY_BARRIER]: {
    selectedType: mergeDeep({}, safetyBarrierButtons.buttonsOptions[0]),
    selectedSubtype: mergeDeep({}, safetyBarrierButtons.buttonsOptions[0].subtypes[0]),
    selectedPlate: mergeDeep({}, safetyBarrierButtons.buttonsOptions[0].subtypes[0].plate[1]),

    profile: {
      material: null, //defaultMaterialState[BRAND][APP_TYPES.SAFETY_BARRIER],
      family: null, //defaultProfileState[APP_TYPES.SAFETY_BARRIER][0].family,
      size: null, //defaultProfileState[APP_TYPES.SAFETY_BARRIER][0].size,
      shape: null,

      rotation: 0,
      rotateDirection: null
    },

    predefinedBasePlate: {
      isPredefinedBasePlate: false,
      selectedManufacturer: '',
      selectedDesignationId: '',
      predefinedBasePlateImgPath: ''
    },

    cladding: CladdingTypes.None
  },

  [APP_TYPES.REBAR_REINFORCEMENT]: {
    activeBtn: '1'
  },
  [APP_TYPES.WOOD_CONNECTION]: {
    selectedTypeId: 0,
    profile: {
      material: null,
      family: null,
      size: null,
      shape: null
    },
    woodPanel: {
      T: woodConnectionButtons.woodConnectionTypes[0].woodPanel.T,
      L: woodConnectionButtons.woodConnectionTypes[0].woodPanel.L,
      thicknessE1: woodConnectionButtons.woodConnectionTypes[0].woodPanel.thicknessE1,
      thicknessE2: woodConnectionButtons.woodConnectionTypes[0].woodPanel.thicknessE2 || 0,
      image: woodConnectionButtons.woodConnectionTypes[0].woodPanel.image
    },
    woodConnectionTypes: woodConnectionButtons.woodConnectionTypes
  }

};

const application = (state = initState, action) => {
  switch (action.type) {
    case SET_SQUARE_ACTIVE_BTN: {
      state[APP_TYPES.GENERAL_CALCULATION].activeSquareBtn = action.id;
      state[APP_TYPES.GENERAL_CALCULATION].activeCircleBtn = null;
      state[APP_TYPES.GENERAL_CALCULATION].activeTriangleBtn = null;
      state[APP_TYPES.GENERAL_CALCULATION].activeEditorBtn = null;

      return { ...state };
    }
    case SET_CIRCLE_ACTIVE_BTN: {
      state[APP_TYPES.GENERAL_CALCULATION].activeSquareBtn = null;
      state[APP_TYPES.GENERAL_CALCULATION].activeCircleBtn = action.id;
      state[APP_TYPES.GENERAL_CALCULATION].activeTriangleBtn = null;
      state[APP_TYPES.GENERAL_CALCULATION].activeEditorBtn = null;

      return { ...state };
    }
    case SET_TRIANGLE_ACTIVE_BTN: {
      state[APP_TYPES.GENERAL_CALCULATION].activeSquareBtn = null;
      state[APP_TYPES.GENERAL_CALCULATION].activeCircleBtn = null;
      state[APP_TYPES.GENERAL_CALCULATION].activeTriangleBtn = action.id;
      state[APP_TYPES.GENERAL_CALCULATION].activeEditorBtn = null;

      return { ...state };
    }
    case SET_EDITOR_ACTIVE_BTN: {
      state[APP_TYPES.GENERAL_CALCULATION].activeSquareBtn = null;
      state[APP_TYPES.GENERAL_CALCULATION].activeCircleBtn = null;
      state[APP_TYPES.GENERAL_CALCULATION].activeTriangleBtn = null;
      state[APP_TYPES.GENERAL_CALCULATION].activeEditorBtn = action.isActive;

      return { ...state };
    }

    case SET_STAND_OFF_ACTIVE_BTN: {
      state[APP_TYPES.GENERAL_CALCULATION].activeStandOffBtn = action.id;

      return { ...state };
    }



    case SET_PROFILE_MATERIAL: {
      if(action.appType !== APP_TYPES.REBAR_REINFORCEMENT) {
        state[action.appType].profile.material = action.value;
      }

      return { ...state };
    }
    case SET_PROFILE_FAMILY: {
      if(action.appType !== APP_TYPES.REBAR_REINFORCEMENT && action.appType !== APP_TYPES.WOOD_CONNECTION) {
        // state[action.appType].profile.family = action.value;
        return mergeDeep({}, state, {
          [action.appType]: {
            profile: {
              family: action.value
            }
          }
        });
      }
      
      return { ...state };
    }
    case SET_PROFILE_SIZE: {
      if(action.appType !== APP_TYPES.REBAR_REINFORCEMENT && action.appType !== APP_TYPES.WOOD_CONNECTION) {
        state[action.appType].profile.size = action.value;
      }

      return { ...state };
    }
    case SET_PROFILE_ROTATION: {
      if(action.appType !== APP_TYPES.REBAR_REINFORCEMENT && action.appType !== APP_TYPES.WOOD_CONNECTION) {
        return mergeDeep({}, state, {
          [action.appType]: {
            profile: {
              rotation: action.value
            }
          }
        });
      }

      return { ...state };
    }
    case SET_PROFILE_ROTATE_DIRECTION: {
      if(action.appType !== APP_TYPES.REBAR_REINFORCEMENT && action.appType !== APP_TYPES.WOOD_CONNECTION) {
        state[action.appType].profile.rotateDirection = action.value;
      }

      return { ...state };
    }

    case SET_SAFETY_BARRIER_ACTIVE_TYPE: {
      if (action.id) {
        state[APP_TYPES.SAFETY_BARRIER].selectedType = state.safetyBarrierButtons.buttonsOptions
          .find(item => item.id === action.id);
      } else {
        state[APP_TYPES.SAFETY_BARRIER].selectedType = state.safetyBarrierButtons.buttonsOptions[0];
      }

      return { ...state };
    }
    case SET_SAFETY_BARRIER_ACTIVE_SUBTYPE: {
      if (action.id) {
        state[APP_TYPES.SAFETY_BARRIER].selectedSubtype = state[APP_TYPES.SAFETY_BARRIER].selectedType.subtypes
          .find(item => item.id === action.id);
      } else {
        state[APP_TYPES.SAFETY_BARRIER].selectedSubtype = state[APP_TYPES.SAFETY_BARRIER].selectedType.subtypes[0];
      }

      return { ...state };
    }
    case SET_SAFETY_BARRIER_ACTIVE_PLATE: {
      if (action.id) {
        state[APP_TYPES.SAFETY_BARRIER].selectedPlate = state[APP_TYPES.SAFETY_BARRIER].selectedSubtype.plate
          .find(item => item.id === action.id);
      } else {
        state[APP_TYPES.SAFETY_BARRIER].selectedPlate = state[APP_TYPES.SAFETY_BARRIER].selectedSubtype.plate[0];
      }

      return { ...state };
    }
    case SET_CLADDING: {
      return mergeDeep({}, state, {
        [action.appType]: {
          cladding: action.value
        }
      });
    }

    case SET_BRACKET_ATTACHMENT_ACTIVE_BTN: {
      state[APP_TYPES.BRACKET_ATTACHMENT].activeBtn = action.id;

      return { ...state };
    }

    case SET_REBAR_REINFORCEMENT_ACTIVE_BTN: {
      state[APP_TYPES.REBAR_REINFORCEMENT].activeBtn = action.id;

      return { ...state };
    }

    case SET_WOOD_PANEL_OPTIONS: {
      return mergeDeep({}, state, {
        [APP_TYPES.WOOD_CONNECTION]: action.options
      });
    }

    case SET_WOOD_CONNECTION_TYPE: {
      return mergeDeep({}, state, {
        [APP_TYPES.WOOD_CONNECTION]: {
          selectedTypeId: action.value
        }
      });
    }

    case RESET_PROFILES: {
      return mergeDeep({}, state, {
        [APP_TYPES.GENERAL_CALCULATION]: {
          profile: {
            family: null,
            size: null, 
            shape: null,
          }
        },
        [APP_TYPES.BRACKET_ATTACHMENT]: {
          profile: {
            family: null,
            size: null, 
            shape: null,
          }
        },
        [APP_TYPES.SAFETY_BARRIER]: {
          profile: {
            family: null,
            size: null, 
            shape: null,
          }
        }
      });
    }
    case RESET_APPLICATION_STATE: {
      return mergeDeep({}, state, {
        [action.appType]: mergeDeep({}, initState[action.appType])
      });
    }
    case SET_APPLICATION_STATE: {
      return action.state;
    }
    case SET_MANUFACTURER: {
      return mergeDeep({}, state, {
        [action.appType]: { 
          predefinedBasePlate: {
            selectedManufacturer: action.value 
          }
        }
      });
    }
    case SET_DESIGNATION: {
      return mergeDeep({}, state, {
        [action.appType]: { 
          predefinedBasePlate: {
            selectedDesignationId: action.id, 
          }
        }
      });
    }
    case SET_PREDEFINED_BASEPLATE: {
      return mergeDeep({}, state, {
        [action.appType]: { 
          predefinedBasePlate: {
            isPredefinedBasePlate: action.value 
          }
        }
      });
    }
    case SET_PREDEFINED_BASEPLATE_IMAGE: {
      return mergeDeep({}, state, {
        [action.appType]: { 
          predefinedBasePlate: {
            predefinedBasePlateImgPath: action.imagePath 
          }
        }
      });
    }
    default: {
      return state;
    }
  }
};

export default application;



// WEBPACK FOOTER //
// ./src/reducers/selectors/application/index.js